import React from "react";
import {Navigate} from "react-router-dom";
import {JSX} from "react/jsx-runtime";
import AdminLayout from "../layouts/AdminLayout";

interface ProtectedRouteProps {
    children: JSX.Element;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
    const token = localStorage.getItem("token");

    if (!token) {
        return <Navigate to="/admin/login" replace />;
    }

    return <AdminLayout> {children} </AdminLayout>;
};

export default ProtectedRoute;
